// extracted by mini-css-extract-plugin
export default {"very-large-text-box":"umskZObCyqgQ16w1sRjo","box-inner":"ioFH2SdYFy9KbEA35rqr","common_bganimation":"XyE3D0Y_1dZqAyZYmnUU"};